import { BaseService } from '@common/http-layer/service/base.service'

import type { LibraryProducts } from '@courses/types-layer/types/library'
import type { DiscoverProductsResponse, UpsellProductsResponse } from '../types/library'

export class LibraryService extends BaseService {
  constructor() {
    super({
      baseURL: 'REST_API_URLS',
      basePath: '',
      headers: {
        version: '2021-07-28',
      },
    })
  }

  private endpoint(path: string, locationId: string): string {
    if (!locationId) throw new Error('Location ID is required')
    return `/courses/learners/locations/${locationId}/courses/library${path}`
  }

  async findAllProducts(locationId: string): Promise<LibraryProducts> {
    const { data } = await this.get<LibraryProducts>(this.endpoint('', locationId), {
      locationId,
    })
    return data
  }

  async findUpsellProducts(locationId: string, params: { page: number; limit: number }): Promise<UpsellProductsResponse> {
    const { data } = await this.get<UpsellProductsResponse>(this.endpoint('/upsell', locationId), {
      params,
      locationId,
    })
    return data
  }

  /**
   * Client Portal Discover feed. Separate endpoint from `/upsell` (different response shape:
   * a `kind`-discriminated union of bundles and single courses), so it gets its own call.
   */
  async findDiscoverProducts(locationId: string, params: { page: number; limit: number }): Promise<DiscoverProductsResponse> {
    const { data } = await this.get<DiscoverProductsResponse>(this.endpoint('/discover', locationId), {
      params,
      locationId,
    })
    return data
  }
}
